import {Header, HeaderContent, Icon, Segment, Tab} from "semantic-ui-react";
import ManageUsersPage from "./manageUsersPage";
import React from "react";
import HeaderSubHeader from "semantic-ui-react/dist/commonjs/elements/Header/HeaderSubheader";

function AdminPage(){
    var panes = [
        {
            menuItem: { key: 'Users', content: 'Manage Users' },
            render: () => <ManageUsersPage/>
        }];
    
    return(
        <Segment basic>
            <Header as="h1">
                <Icon name='key' color={'yellow'}></Icon>
                <HeaderContent>
                    App Administration
                    <HeaderSubHeader>
                        Manage users and settings
                    </HeaderSubHeader>
                </HeaderContent>
            </Header>
            <Tab panes={panes}></Tab>
        </Segment>
    )
}
export default AdminPage;